module.exports = __webpack_public_path__ + "img/40b5fe2a-6649-423c-86e9-42b0c6472d7e.f4d84275.png";